let apiBase = '/api/onapi/'

if (process.env.NODE_ENV === 'development') {
  apiBase = 'http://localhost:8080' + apiBase
}

module.exports = {
  api_base: apiBase,
  product: 'Flow-Access'
}



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/config/installation.js